import React from 'react';
import Navigation from './Navigation';
import Hero from './Hero';
import ValueProps from './ValueProps';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#050505] font-inter">
      <Navigation />
      <Hero />
      <ValueProps />
      <Footer />
    </div>
  );
};

export default LandingPage;
